(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = Array.from(document.querySelectorAll('.book-entry-filter__filter-btn'));
    const entries = document.querySelectorAll('.book-entry');
    const prevBtn = document.querySelector('.filter-prev');
    const nextBtn = document.querySelector('.filter-next');
    const filterBar = document.querySelector('.book-entry-filter');
    let lastScrollY = window.scrollY;
    let isScrollingUp = false;
    let scrollTimeout;
    let filterBarTop = 0;

    if (!buttons.length || !entries.length) return;

    // Calculate filter bar position once
    if (filterBar) {
      const filterBarRect = filterBar.getBoundingClientRect();
      filterBarTop = filterBarRect.top + window.scrollY;
    }

    // Add loading state to entries
    entries.forEach(entry => {
      entry.classList.add('loading');
    });

    // Function to remove loading state
    function removeLoadingState() {
      entries.forEach(entry => {
        entry.classList.remove('loading');
      });
    }

    // Simulate loading time (you can remove this in production)
    setTimeout(removeLoadingState, 500);

    // Add transition styles to the filter bar
    if (filterBar) {
      filterBar.style.transition = 'transform 0.3s ease, opacity 0.3s ease, top 0.3s ease, position 0.3s ease';
      filterBar.style.willChange = 'transform, opacity, top, position';
    }

    // Add scroll event listener for mobile filter visibility
    window.addEventListener('scroll', () => {
      // Only apply on mobile
      clearTimeout(scrollTimeout);

      const currentScrollY = window.scrollY;
      isScrollingUp = currentScrollY < lastScrollY;

      if (filterBar) {
        const filterBarRect = filterBar.getBoundingClientRect();
        const isAboveOriginalPosition = currentScrollY < filterBarTop;
        // Responsive nav height: 60px for ≤768px, 99px for 768px-1180px
        const navHeight = window.innerWidth <= 1024 ? 60 : 99;
        const hasReachedViewportTop = filterBarRect.top <= navHeight;

        // Always show filter bar when above its original position
        if (isAboveOriginalPosition) {
          requestAnimationFrame(() => {
            filterBar.style.position = 'relative';
            filterBar.style.top = '0';
            filterBar.style.transform = 'translateY(0)';
            filterBar.style.opacity = '1';
          });
        } else {
          // Make it sticky when we reach the top
          requestAnimationFrame(() => {
            filterBar.style.position = 'fixed';
            filterBar.style.top = navHeight + 'px';
            filterBar.style.left = '0';
            filterBar.style.right = '0';
            filterBar.style.zIndex = '10';
            filterBar.style.backgroundColor = '#fff';
          });

          if (hasReachedViewportTop) {
            // Hide when scrolling down, show when scrolling up
            if (isScrollingUp) {
              requestAnimationFrame(() => {
                filterBar.style.transform = 'translateY(0)';
                filterBar.style.opacity = '1';
              });
            } else {
              requestAnimationFrame(() => {
                filterBar.style.transform = 'translateY(-100%)';
                filterBar.style.opacity = '0';
              });
            }
          }
        }
      }

      lastScrollY = currentScrollY;

      // Add a small delay before hiding to prevent flickering
      scrollTimeout = setTimeout(() => {
        if (!isScrollingUp && filterBar && currentScrollY >= filterBarTop) {
          const filterBarRect = filterBar.getBoundingClientRect();
          // Responsive nav height: 60px for ≤768px, 99px for 768px-1180px
          const navHeight = window.innerWidth <= 1024 ? 60 : 99;
          if (filterBarRect.top <= navHeight) {
            requestAnimationFrame(() => {
              filterBar.style.transform = 'translateY(-100%)';
              filterBar.style.opacity = '0';
            });
          }
        }
      }, 50);
    });

    // Add styles for the skeleton loading
    const style = document.createElement('style');
    style.textContent = `
      .book-entries-container {
        position: relative;
      }
      .book-entries-loading {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        z-index: 100;
        opacity: 1;
      }
      .book-entries-content {
        transition: opacity 0.3s ease;
        opacity: 0;
      }
      .skeleton {
        background: #fff;
        border-radius: 4px;
        margin-bottom: 20px;
        padding: 20px;
        box-shadow: 0 2px 4px rgba(0,0,0,0.1);
        opacity: 1;
      }
      .skeleton-image {
        width: 100%;
        height: 300px;
        background: linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%);
        background-size: 200% 100%;
        animation: shimmer 2s infinite;
        border-radius: 4px;
      }
      .skeleton-text {
        height: 20px;
        margin: 15px 0;
        background: linear-gradient(90deg, #e0e0e0 25%, #d0d0d0 50%, #e0e0e0 75%);
        background-size: 200% 100%;
        animation: shimmer 2s infinite;
        border-radius: 4px;
      }
      .skeleton-text:nth-child(1) { width: 80%; }
      .skeleton-text:nth-child(2) { width: 60%; }
      .skeleton-text:nth-child(3) { width: 70%; }
      @keyframes shimmer {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
      }
    `;
    document.head.appendChild(style);

    // Initial load with skeleton
    const entriesContainer = document.querySelector('.book-entries-content');
    const loadingSpinner = document.querySelector('.book-entries-loading');

    if (entriesContainer && loadingSpinner) {
      entriesContainer.style.opacity = '0';
      loadingSpinner.style.display = 'block';

      // Show actual content after delay
      setTimeout(() => {
        entriesContainer.style.opacity = '1';
        loadingSpinner.style.display = 'none';
      }, 1000);
    }

    function applyFilterByIndex(index) {
      if (index < 0 || index >= buttons.length) return;

      const button = buttons[index];
      const [high, low] = button.dataset.range.split('-').map(Number);
      const icon = document.querySelector('.book-entry-filter .icon');
      const targetButton = buttons[index];
      const loadingSpinner = document.querySelector('.book-entries-loading');
      const entriesContainer = document.querySelector('.book-entries-content');

      // Show loading spinner
      if (loadingSpinner && entriesContainer) {
        loadingSpinner.style.display = 'block';
        entriesContainer.style.opacity = '0';
      }

      // Move icon into the target button
      if (icon && targetButton) {
        targetButton.insertBefore(icon, targetButton.firstChild);
      }

      // Toggle active state and disable/enable buttons
      buttons.forEach(btn => {
        btn.classList.remove('active');
        btn.disabled = false;
      });
      button.classList.add('active');
      button.disabled = true;

      // Show/hide entries with loading state
      entries.forEach(entry => {
        const rank = parseInt(entry.dataset.rank, 10);
        // Handle both ascending and descending ranges
        const inRange = high >= low ? rank <= high && rank >= low : rank >= high && rank <= low;

        if (inRange) {
          entry.classList.add('loading');
          entry.classList.remove('is-visible');

          // Simulate loading time for filtered entries
          setTimeout(() => {
            entry.classList.remove('loading');
            entry.classList.add('is-visible');
            // Hide loading spinner after entries are shown
            if (loadingSpinner && entriesContainer) {
              loadingSpinner.style.display = 'none';
              entriesContainer.style.opacity = '1';
            }
          }, 1000); // Increased to 1 second
        } else {
          entry.classList.remove('is-visible', 'loading');
        }
      });

      updatePaginationLabels(index);
    }

    function updatePaginationLabels(currentIndex) {
      if (prevBtn) {
        if (currentIndex > 0) {
          const prevLabel = buttons[currentIndex - 1].textContent.trim();
          prevBtn.textContent = `← Show ${prevLabel}`;
          prevBtn.disabled = false;
        } else {
          prevBtn.textContent = '←';
          prevBtn.disabled = true;
        }
      }

      if (nextBtn) {
        if (currentIndex < buttons.length - 1) {
          const nextLabel = buttons[currentIndex + 1].textContent.trim();
          nextBtn.textContent = `Show ${nextLabel} →`;
          nextBtn.disabled = false;
        } else {
          nextBtn.textContent = '→';
          nextBtn.disabled = true;
        }
      }
    }

    // Set up filter button clicks
    buttons.forEach((btn, i) => {
      btn.addEventListener('click', e => {
        applyFilterByIndex(i);
        // Scroll to bottom of article container
        const articleContainer = document.querySelector('.article__container');
        if (articleContainer) {
          const containerRect = articleContainer.getBoundingClientRect();
          const scrollPosition = window.scrollY + containerRect.bottom;
          window.scrollTo({
            top: scrollPosition,
            behavior: 'smooth'
          });
        }
        // Prevent sticky jump by blurring the button
        e.currentTarget.blur();
      });
    });

    // Pagination buttons
    prevBtn?.addEventListener('click', () => {
      const currentIndex = buttons.findIndex(btn => btn.classList.contains('active'));
      if (currentIndex > 0) {
        applyFilterByIndex(currentIndex - 1);
        const filterBar = document.querySelector('.article__banner');
        if (filterBar) {
          const y = filterBar.getBoundingClientRect().bottom + window.scrollY;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    });

    nextBtn?.addEventListener('click', () => {
      const currentIndex = buttons.findIndex(btn => btn.classList.contains('active'));
      if (currentIndex < buttons.length - 1) {
        applyFilterByIndex(currentIndex + 1);
        const filterBar = document.querySelector('.article__banner');
        if (filterBar) {
          const y = filterBar.getBoundingClientRect().bottom + window.scrollY;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    });

    // On page load: activate first filter or active one
    let activeIndex = buttons.findIndex(btn => btn.classList.contains('active'));
    if (activeIndex === -1) {
      activeIndex = 0;
      buttons[0].classList.add('active');
    }
    applyFilterByIndex(activeIndex);
  });

  } catch(e) { console.error(e); }
})();
})();
